import styled from "styled-components/macro";
import bg from "../../assets/bgs/kindle.jpg";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { Grid, Paper, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import MoneyPerMonth from "../upgradePlan/MoneyPerMonth";
import PrimaryButton from "../../components/custom/PrimaryButton";
import { useNavigate, useSearchParams } from "react-router-dom";

function PaymentSuccess() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const productName = searchParams.get("name");
  const productPrice = searchParams.get("price");
  const productDescr = searchParams.get("descr");
  const handleGoToWebsite = () => {
    navigate("/");
  };
  return (
    <MessageWrapper>
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        height={"100vh"}
      >
        <Grid item xs={2}>
          <StyledIcon />
        </Grid>
        <Grid
          item
          xs={8}
          spacing={1}
          container
          direction="column"
          alignItems="center"
        >
          <Grid item xs={4}>
            <StyledTypographyPayment>
              {t("Payment was processed succesfully")}
            </StyledTypographyPayment>
            <StyledTypographyProductPurchase variant="h3">
              {t("You purchased")} {productName}
            </StyledTypographyProductPurchase>
          </Grid>
          <Grid item xs={4} width="50%">
            <StyledPaper>
              <Typography variant="h4">{productName}</Typography>
              <MoneyPerMonth
                price={productPrice}
                perDescription={productDescr == "Custom" ? "/Unit" : "/Package"}
              />
            </StyledPaper>
          </Grid>
          <Grid item xs={1}>
            <Typography
              variant="h5"
              sx={{
                color: `#fff`,
                textAlign: "center",
              }}
            >
              {t("Click the button to return to the website")}
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={1}>
          <PrimaryButton onClick={handleGoToWebsite} sx={{ mt: 4 }}>
            {t("GO TO WEBSITE")}
          </PrimaryButton>
        </Grid>
      </Grid>
    </MessageWrapper>
  );
}

const MessageWrapper = styled(Grid)`
  background-image: url(${bg});

  background: linear-gradient(
      ${(props) => props.theme.palette.authBg.background},
      ${(props) => props.theme.palette.authBg.background}
    ),
    url(${bg});
  background-size: cover;
  background-repeat: no-repeat;
  height: 100vh;
  justify-content: center;
`;

const StyledIcon = styled(CheckCircleOutlineIcon)`
  color: green;
  height: 10rem;
  width: 10rem;
`;

const StyledTypographyPayment = styled(Typography)`
  color: ${(props) => props.theme.palette.primary.contrastText};
  text-align: center;
  font-size: 3rem;
`;

const StyledTypographyProductPurchase = styled(Typography)`
  color: ${(props) => props.theme.palette.primary.main};
  text-align: center;
`;

const StyledPaper = styled(Paper)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 1rem;
  padding: 0.7rem;
`;
export default PaymentSuccess;
